// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TermsOfUse_wrapper__1CsJY","underline":"TermsOfUse_underline__3Ny_X","paragraph":"TermsOfUse_paragraph__3kPrY","italic":"TermsOfUse_italic__3gweT"};